import React, { Component } from 'react';
import Footer from '../footer/newfooter';
import Header from '../header/newheader'
import { Link } from 'react-router-dom'
import { List } from 'react-content-loader'
import Axios from 'axios';
import { BASE } from '../api/api'


class submitted_more extends Component {
    constructor(props) {
        super(props);
        this.state = {
            prev: false,
            next: false,
            nav: false,
            page: 0
        };

    }
    componentWillMount() {
        this.setState({
            datz: undefined
        })
        let dat = JSON.parse(localStorage.getItem('submit_data'))
        console.log(dat)
        this.getData(dat.type, 0)

        // this.setState({
        //     sub_data: dat
        // })
    }

    handleNav(type) {
        let pg = this.state.page;
        this.setState({
            nav: false
        })
        if (type == 'prev') {
            pg = pg > 0 ? pg - 1 : 0
        }
        else if (type == 'next') {
            pg = pg + 1
        }

        this.getData(this.state.type, pg, type)
    }
    getData(dat, page, type) {
        console.log(dat, page)
        if (this.state.next_datz && type == "next") {
                this.setState({
                    datz: undefined
                })
                // nxt / prev data
                Axios.get(BASE+'jsonapi/node/submit_for_work?filter[titleFilter][condition][path]=field_select_work_to_submit.name&filter[titleFilter][condition][value]='+dat+'&sort=-created&page[limit]=10&page[offset]=' + (page + 1) * 10)
                    .then((next_datz) => {
                        if (next_datz.data.data.length > 0) {
                            console.log(page)
                            if (page > 0) {
                                this.setState({
                                    prev: true, nav: true,
                                    page: page
                                })
                            }
                            else {
                                this.setState({
                                    prev: false,
                                    page: 0
                                })
                            }
                            this.setState({
                                next_datz: undefined,
                                next: true,
                                nav: true
                            })
                            this.setState({
                                next_datz: next_datz.data.data,
                                datz: this.state.next_datz,
                                type: dat
                            })
                        }
                        else {
                            if (page > 0) {
                                this.setState({
                                    prev: true, nav: true
                                })
                            }
                            else {
                                this.setState({
                                    prev: false, nav: false
                                })
                            }
                            this.setState({
                                next: false,
                                datz: this.state.next_datz,
                                type: dat
                            })
                        }
                    })
                // })
            
        }
        else {
            // if (dat == "Articles") {
                
                Axios.get(BASE+'jsonapi/node/submit_for_work?filter[titleFilter][condition][path]=field_select_work_to_submit.name&filter[titleFilter][condition][value]='+dat+'&sort=-created&page[limit]=10&page[offset]=' + page * 10)
                    .then((datz) => {
                        // this.setState({

                        // })
                        // tmp str,nxt / prev data
                        Axios.get(BASE+'jsonapi/node/submit_for_work?filter[titleFilter][condition][path]=field_select_work_to_submit.name&filter[titleFilter][condition][value]='+dat+'&sort=-created&page[limit]=10&page[offset]=' + (page + 1) * 10)
                            .then((next_datz) => {
                                console.log(next_datz.data.data.length)
                                if (next_datz.data.data.length > 0) {
                                    if (page > 0) {
                                        this.setState({
                                            prev: true, nav: true,
                                            page: page
                                        })
                                    }
                                    else {
                                        this.setState({
                                            prev: false,
                                            page: 0,
                                            nav:true
                                        })
                                    }
                                    this.setState({
                                        next_datz: undefined,
                                        next: true,

                                    })
                                    this.setState({
                                        next_datz: next_datz.data.data,
                                        datz: datz.data.data,
                                        type: dat
                                    })
                                }
                                else {
                                    if (page > 0) {
                                        this.setState({
                                            prev: true,
                                            nav: true
                                        })
                                    }
                                    else {
                                        this.setState({
                                            prev: false
                                        })
                                    }
                                    this.setState({
                                        next: false,
                                        datz: datz.data.data,
                                        type: dat
                                    })
                                }
                            })
                    })
                    .catch((err) => {
                        console.log(err)
                    })
        }
    }
    componentWillReceiveProps(nextProps) {
        this.setState({
            datz: undefined
        })
        let dat = JSON.parse(localStorage.getItem('submit_data'))
        console.log(dat)
        this.getData(dat.type, 0)

        // this.setState({
        //     sub_data: dat
        // })
    }
    render() {
        return (
            <div className='formrea yourwork'>
                <Header />

                <div className="listing">


                    <div className="page-title">
                        <div className="title-wrapper">
                            <div className="container">
                                <h1 className="page-header">{this.state.type ? this.state.type : ''}</h1>
                            </div>
                        </div>
                    </div>

                    <div className="main-content">
                        <div className="container">
                            <div className="row">
                                <div className="region region-content">
                                    <div className="listings">

                                        {this.state.datz ?
                                            <div className="mission">
                                                {this.state.datz.map((inst, index) => {
                                                    return (
                                                        <div>
                                                            <div className="title">
                                                                <span className="field-content">
                                                                    <Link to={{ pathname: '/submit_data_details/' + `${inst.attributes.title}`, state: { dat_arr: inst.attributes } }}>{inst.attributes.title}</Link>
                                                                </span>
                                                            </div>

                                                        </div>
                                                    )
                                                })
                                                }
                                                {/* <div className="see_more_submitted">
                                                    <Link to={{ pathname: '/submitted_work/Articles' }} onClick={() => {
                                                        localStorage.removeItem('submit_data')
                                                        localStorage.setItem('submit_data', JSON.stringify({  "type": "Articles" }))
                                                    }} target="_blank">
                                                        <div>See more</div>
                                                    </Link>
                                                </div> */}
                                            </div>
                                            : <List />
                                        }
                                    </div>
                                    {/* <div style={{ display: this.state.nav == true ? '' : "none" }}>
                                        <div style={{ color: this.state.prev == true ? 'green' : 'red' }} onClick={() => this.handleNav('prev')}>Prev</div>
                                        <div style={{ color: this.state.next == true ? 'green' : 'red' }} onClick={() => this.handleNav('next')}>Next</div>
                                    </div> */}

                                    <ul className="pagination" style={{ display: this.state.nav == true ? '' : "none" }}>
                                        <li onClick={() => this.handleNav('prev')} className="previous">
                                            <a style={{ color: this.state.prev == true ? '#165E84 ' : '', fontWeight: this.state.prev == true ? '500' : '', cursor: this.state.prev == true ? '' : 'not-allowed' }} tabindex="0" role="button" className="prev" aria-disabled="true">Previous</a></li>
                                        <li onClick={() => this.handleNav('next')} className="next"><a style={{ color: this.state.next == true ? '#165E84 ' : '', fontWeight: this.state.next == true ? '500' : '', cursor: this.state.next == true ? '' : 'not-allowed' }} tabindex="0" role="button" aria-disabled="false">Next</a></li>

                                    </ul>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <Footer />
            </div>
        );
    }
}

export default submitted_more;